<template>
  <div id="revisions">
    <!-- Revisions drawer -->
    <b-card
      id="revisionsCard"
      class="blockDrawer large"
      :class="$store.state.drawer.blockRevisions.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="closeRevisions()"
        >
          <i class="far fa-times"></i>
        </a>
        <h4 class="card-title">Revisions</h4>
        <b-btn
          @click="downloadCSV()"
          class="mb-2 mr-1"
        >
          <i class="fas fa-file-download"></i> Download CSV
        </b-btn>
      </template>
      <!-- REVISIONS -->
      <div class="list-group" v-if="showRevisions">
        <div class="list-container">
          <div class="list-group-item mb-2">
            <small><strong>CURRENT VERSION</strong><br>Updated: {{ this.$store.state.block.updatedOn | formatDate }}</small>
            <small v-if="this.$store.state.block.updatedByName"> by {{ this.$store.state.block.updatedByName }}</small>
            <p class="mb-1">{{ this.$store.state.block.revisionMessage }}</p>
          </div><!-- /.list-group-item -->
        </div>
        <div
          v-for="(revision, i) in $store.state.revisions"
          v-bind:key="i"
          class="list-container"
        >
          <div class="list-group-item mb-2">
            <small>[{{ i + 1 }}] Updated: {{ revision.updatedOn | formatDate }}</small>
            <small v-if="revision.updatedByName"> by {{ revision.updatedByName }}</small>
            <p class="mb-1">{{ revision.revisionMessage }}</p>
            <b-btn
              size="sm"
              @click="preview(revision)"
            >
              <i class="fas fa-eye"></i> View
            </b-btn>
            <b-btn
              variant="warning"
              size="sm ml-1"
              @click="confirmRevert(revision)"
            >
              <i class="fas fa-history"></i> Revert
            </b-btn>
          </div><!-- /.list-group-item -->
        </div><!-- /.list-container -->
      </div><!-- /.list-group -->
    </b-card>
    <Confirm
      v-if="promptConfirmRevert"
      text="Are you sure you want to revert to this version of the block? A new version will also be created using the current block."
      v-on:confirmed="revert($event)"
    />
  </div><!-- /#revisions -->
</template>

<script>
import Confirm from '../Confirm'
import moment from 'moment'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      promptConfirmRevert: false,
      showRevisions: false
    }
  },
  computed: {
    revision: {
      get () {
        return this.$store.state.revision
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'revision', value: value })
      }
    },
    revisions: {
      get () {
        return this.$store.state.revisions
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'revisions', value: value })
      }
    },
    block: {
      get () {
        return this.$store.state.block
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'block', value: value })
      }
    },
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    }
  },
  components: {
    Confirm
  },
  created () {
    console.log('Loaded Block Revisions Drawer')
    this.revisions = []
    fb.blocksCollection.doc(this.block.id).collection('revisions').orderBy('updatedOn', 'desc').limit(100).get().then(revisionsDocs => {
      revisionsDocs.forEach(revisionDoc => {
        const revisionData = revisionDoc.data()
        revisionData.id = revisionDoc.id
        this.revisions.push(revisionData)
      })
      this.showRevisions = true
    }).catch(err => {
      console.log(err.message)
    })
  },
  methods: {
    downloadCSV () {
      const todayDate = moment().format('YYYY-MM-DD')
      const cleanDescription = this.block.name.replace(/\s+/g, '_')
      const fileName = todayDate + '_' + cleanDescription + '_' + this.block.id + '.csv'
      const items = []
      items.push(this.block)
      this.revisions.forEach((revision, i) => {
        items.push(revision)
      })
      const formattedItems = []
      items.forEach((item, i) => {
        const formattedItem = {}
        // Clean Dates
        const createdOn = item.createdOn.seconds * 1000
        formattedItem.createdOn = moment(createdOn).format()
        const updatedOn = item.updatedOn.seconds * 1000
        formattedItem.updatedOn = moment(updatedOn).format()
        // Setup Lat Long
        // formattedItem.latitude = item.geolocation.latitude
        // formattedItem.longitude = item.geolocation.longitude
        // Handle fields
        if (this.farm.blockFields) {
          this.farm.blockFields.forEach((field, i) => {
            if (field.type !== 'Image') {
              formattedItem[field.label] = item[field.machine_name] || ''
            }
          })
        }
        // Revision Log
        formattedItem.revisionMessage = item.revisionMessage || ''
        // ID
        formattedItem.id = item.id
        // Push to formattedItems
        formattedItems.push(formattedItem)
      })
      const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
      const header = Object.keys(formattedItems[0])
      let csv = formattedItems.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csv.unshift(header.join(','))
      csv = csv.join('\r\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const object = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = object
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    closeRevisions () {
      this.$store.commit('hideDrawer', 'blockRevisions')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'blockDetails')
      }, 300)
    },
    preview (revision) {
      this.revision = revision
      this.$store.commit('hideDrawer', 'blockRevisions')
      setTimeout(() => {
        this.$store.commit('showDrawer', 'previewBlockRevision')
      }, 300)
    },
    confirmRevert (revision) {
      this.revision = revision
      this.promptConfirmRevert = true
    },
    revert (confirmed) {
      this.promptConfirmRevert = false
      if (confirmed) {
        console.log('Revert')
        // Create a revision with the current doc
        fb.blocksCollection.doc(this.block.id).get().then(blockDoc => {
          const blockData = blockDoc.data()
          
          // Create a clean copy for revision (without id field to avoid conflicts)
          const revisionData = { ...blockData }
          delete revisionData.id
          
          return fb.blocksCollection.doc(blockData.id).collection('revisions').add(revisionData)
        }).then(() => {
          this.revision.updatedOn = new Date()
          this.revision.updatedBy = this.$store.state.currentUser.uid
          this.revision.revisionMessage = 'Reverted to previous version: ' + this.revision.revisionMessage
          return fb.blocksCollection.doc(this.block.id).update(this.revision)
        }).then(() => {
          // Mark the farm to recompile
          return fb.farmsCollection.doc(this.farm.id).update({
            recompileBlocks: true
          })
        }).then(() => {
          this.block = this.revision
          this.$store.commit('setAlert', { active: true, message: 'Block Updated! Recompiling map now...', level: 'alert-success' })
          this.$store.commit('hideDrawer', 'blockRevisions')
          return this.$store.dispatch('removeAllLayers')
        }).then(() => {
          const map = this.$store.state.mapObject
          map.removeControl(this.drawControlsObject)
          this.drawControlsObject = false
          this.$store.dispatch('removeAllLayers')
          setTimeout(() => {
            return this.$store.dispatch('initFarmMap')
          }, 300)
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log('Cancelled')
      }
    }
  },
  filters: {
    formatDate (val) {
      if (!val) { return '-' }
      const date = val.toDate()
      return moment(date).fromNow()
      // return moment(date).format('MM/DD/YY')
    }
  }
}
</script>
